var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-list',{staticStyle:{"margin-top":"10px"},attrs:{"data":_vm.data,"columns":_vm.columns,"loading":_vm.loading,"page":_vm.page,"page-size":_vm.page.pageSize,"table-style":{ name: 'mixture' }},on:{"page-size-changed":_vm.pageSizeChanged,"page-changed":_vm.pageChanged,"sort-change":_vm.sortChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }